import { useContext } from 'react';
import type { TokenContextProps } from '../components/TokenProvider/TokenContext';
import TokenContext from '../components/TokenProvider/TokenContext';

export default function useToken(): TokenContextProps {
  return useContext(TokenContext);
}
